import type { IconSvgObject } from './types';

const BrickWallIcon: IconSvgObject = [
  ["path", { d: "M3 13V11C3 7.22876 3 5.34315 4.17157 4.17157C5.34315 3 7.22876 3 11 3H13C16.7712 3 18.6569 3 19.8284 4.17157C21 5.34315 21 7.22876 21 11V13C21 16.7712 21 18.6569 19.8284 19.8284C18.6569 21 16.7712 21 13 21H11C7.22876 21 5.34315 21 4.17157 19.8284C3 18.6569 3 16.7712 3 13Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 9H3H7.5M12 9V15M12 9H21H16.5M12 15H3H7.5M12 15H21H16.5M7.5 3.5V9M7.5 9H16.5M16.5 3.5V9M7.5 15V20.5M7.5 15H16.5M16.5 15V20.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default BrickWallIcon;
